import { ChevronRight, Home } from 'lucide-react';
import { Link } from 'react-router';
import { cx } from '../ui/cx';

export interface Crumb {
  label: string;
  /** Omit for the current page (last crumb). */
  to?: string;
}

/**
 * Breadcrumbs (APG "Breadcrumb"): <nav aria-label="Breadcrumb"> with an ordered list; the current
 * page is plain text with aria-current="page"; separators are hidden from AT. On phones only the
 * parent and current page are shown to avoid wrapping.
 */
export function Breadcrumbs({
  items,
  label = 'Breadcrumb',
  className,
}: {
  items: readonly Crumb[];
  label?: string;
  className?: string;
}) {
  return (
    <nav aria-label={label} className={cx('min-w-0', className)}>
      <ol className="flex min-w-0 items-center gap-1 text-sm">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          const nearEnd = i >= items.length - 2;
          return (
            <li
              key={`${c.label}-${i}`}
              className={cx('flex min-w-0 items-center gap-1', !nearEnd && 'hidden md:flex')}
            >
              {i > 0 && (
                <ChevronRight aria-hidden="true" className="size-3.5 shrink-0 text-ink-muted" />
              )}
              {c.to && !last ? (
                <Link to={c.to} className="flex items-center gap-1 truncate">
                  {i === 0 && <Home aria-hidden="true" className="size-3.5 shrink-0" />}
                  {c.label}
                </Link>
              ) : (
                <span aria-current={last ? 'page' : undefined} className="truncate text-ink">
                  {c.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
